module.exports = __webpack_public_path__ + "static/media/space-4.2078e91e.png";